import React, {Component} from "react";
import {Var} from "../../../App";
import PropTypes from "prop-types";
import Select2 from "react-select2-wrapper";
import 'react-select2-wrapper/css/select2.min.css';
import './index.css';

class Select extends Component {
    constructor(props) {
        super(props);

        this.state = {
            disabled: false,
            readOnly: false,
            error: null,
            value: props.value,
            id: `inp_${Var.shuffle('string', 6)}`
        };

        this.ref = {
            input: React.createRef()
        }
    }

    static defaultProps = {
        className: null,
        style: {},
        align: 'right',
        direction: 'rtl',
        label: null,
        placeholder: null,
        searchPlaceholder: 'جستجو...',
        id: null,
        name: null,
        readOnly: false,
        disabled: false,
        value: [{id: '', text: '...'}],
        options: [],
        multiple: false,
        onChange: _ => null,
        onClick: _ => null,
        onOpen: _ => null,
        onClose: _ => null,
        validation: _ => true
    }

    static propTypes = {
        className: PropTypes.string,
        style: PropTypes.object,
        align: PropTypes.oneOf(['left', 'center', 'right']),
        direction: PropTypes.oneOf(['ltr', 'rtl']),
        label: PropTypes.string,
        placeholder: PropTypes.string,
        searchPlaceholder: PropTypes.string,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        name: PropTypes.string,
        readOnly: PropTypes.bool,
        disabled: PropTypes.bool,
        value: PropTypes.array,
        options: PropTypes.array,
        multiple: PropTypes.bool,
        onChange: PropTypes.func,
        onClick: PropTypes.func,
        onOpen: PropTypes.func,
        onClose: PropTypes.func,
        validation: PropTypes.func
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.props.value !== nextProps.value) {
            nextState.value = nextProps.value;
        }

        return this.state.disabled !== nextState.disabled ||
            this.state.readOnly !== nextState.readOnly ||
            this.state.error !== nextState.error ||
            this.state.value !== nextState.value ||
            this.props.readOnly !== nextProps.readOnly ||
            this.props.disabled !== nextProps.disabled ||
            this.props.className !== nextProps.className ||
            this.props.value !== nextProps.value ||
            this.props.options !== nextProps.options;
    }

    render() {
        const {state, props} = this;
        const cls = ['Select', props.align];
        const options = [...props.options];
        const readOnly = state.readOnly || props.readOnly;
        const disabled = state.disabled || props.disabled;
        const id = props.id || state.id;
        let label = null;

        !readOnly && !disabled && state.error && cls.push('error');

        props.className && cls.push(props.className);
        readOnly && cls.push('read-only');
        disabled && cls.push('disabled');
        props.label && (label = <label className={'Select-label'} htmlFor={id} onClick={this.openSelect.bind(this)}>{props.label}</label>);

        //if forced flag added to values of select, the values should be added to options event if it doesn't contain
        for (let item of state.value || []) {
            if (item.forced) {
                if (!options.find(opt => opt.id === item.id)) {
                    options.push(item);
                }
            }
        }

        return (<div className={cls.join(' ')} style={props.style} onKeyPress={this.openSelect.bind(this)}>
            {label}
            <Select2 ref={this.ref.input}
                     id={id}
                     name={props.name || id}
                     value={(state.value || []).map(item => item.id)}
                     readOnly={readOnly}
                     disabled={disabled}
                     multiple={props.multiple}
                     data={options}
                     options={{
                         placeholder: props.placeholder,
                         minimumResultsForSearch: 5,
                         language: {
                             errorLoading: _ => 'امکان بارگذاری نتایج وجود ندارد.',
                             inputTooLong: args => `حداکثر ${args.maximum} کاراکتر می توانید جستجو کنید.`,
                             inputTooShort: args => `حداقل ${args.minimum} کاراکتر برای جستجو باید وارد کنید.`,
                             loadingMore: _ => 'در حال بارگذاری نتایج بیشتر...',
                             maximumSelected: args => `حداکثر ${args.maximum} گزینه می توانید انتخاب کنید.`,
                             noResults: _ => 'نتیجه‌ای پیدا نشد',
                             searching: _ => 'در حال جستجو...',
                             removeAllItems: _ => 'همه موارد را حذف کنید'
                         }
                     }}
                     onSelect={this.inputChangeHandler.bind(this)}
                     onUnselect={this.inputChangeHandler.bind(this)}
                     onOpen={this.inputOpenHandler.bind(this)}
                     onClose={this.inputCloseHandler.bind(this)}
                     onClick={this.props.onClick}/>
            {state.error && <p className={'Select-error'}>{state.error}</p>}
        </div>);
    }

    error(prompt = null) {
        this.setState({error: prompt});
    }

    inputChangeHandler(event) {
        const {props} = this;
        let value = this.ref.input.current.el.select2('data') || [];

        value = value.map(item => {
            return {
                ...item,
                // eslint-disable-next-line eqeqeq
                ...props.options.find(opt => opt.id == item.id)
            }
        });

        this.setState({value}, _ => {
            this.validate(value);
            props.onChange(value);
        });
    }

    inputCloseHandler(event) {
        const {props} = this;

        props.onClose(event);
    }

    inputOpenHandler(event) {
        const {state, props} = this;
        const readOnly = props.readOnly || state.readOnly;
        const disabled = props.disabled || state.disabled;

        document.querySelectorAll('.select2-search__field')[0].placeholder = props.searchPlaceholder || '';

        if (readOnly || disabled) {
            this.ref.input.current.el.select2('close');
            return;
        }

        props.onOpen(event);
    }

    openSelect() {
        const {state, props} = this;
        const readOnly = props.readOnly || state.readOnly;
        const disabled = props.disabled || state.disabled;

        if (!readOnly && !disabled) {
            this.ref.input.current.el.select2('open');
        }
    };

    validate(value = this.state.value) {
        const {props} = this;
        const validate = props.validation(value);

        if (validate === true)
            this.error();
        else
            this.error(validate);

        return validate === true ? true : {
            label: props.label || props.placeholder || '',
            message: validate
        };
    }
}

export default Select